import React, { createContext, useContext, useRef } from 'react'

const FlyingAnimationContext = createContext()

export const FlyingAnimationProvider = ({ children }) => {
  const cartIconRef = useRef(null)

  return (
    <FlyingAnimationContext.Provider value={{ cartIconRef }}>
      {children}
    </FlyingAnimationContext.Provider>
  )
}

export const useFlyingAnimationContext = () => {
  const context = useContext(FlyingAnimationContext)
  if (!context) {
    throw new Error('useFlyingAnimationContext must be used within FlyingAnimationProvider')
  }
  return context
}